var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getUnicodeText, textTrim, withInBounds } from '../../common/utils/helper';
import { BaseLegend, LegendOptions } from '../../common/legend/legend';
import { measureText } from '@syncfusion/ej2-svg-base';
import { legendClick, legendRender, regSub, regSup } from '../../common/model/constants';
import { measureLegendTemplateSize } from '../../common/utils/helper';
import { StockChartBorder, StockChartFont, StockMargin } from '../model/base';
import { Browser, isNullOrUndefined } from '@syncfusion/ej2-base';
import { Property, Complex, ChildProperty } from '@syncfusion/ej2-base';
import { ContainerPadding, Location } from '../../common/model/base';
/**
 * Configures the legends in charts.
 */
export class StockChartLegendSettings extends ChildProperty {
}
__decorate([
    Property(false)
], StockChartLegendSettings.prototype, "visible", void 0);
__decorate([
    Property(null)
], StockChartLegendSettings.prototype, "height", void 0);
__decorate([
    Property(null)
], StockChartLegendSettings.prototype, "width", void 0);
__decorate([
    Complex({ x: 0, y: 0 }, Location)
], StockChartLegendSettings.prototype, "location", void 0);
__decorate([
    Property('Auto')
], StockChartLegendSettings.prototype, "position", void 0);
__decorate([
    Property('Series')
], StockChartLegendSettings.prototype, "mode", void 0);
__decorate([
    Property(8)
], StockChartLegendSettings.prototype, "padding", void 0);
__decorate([
    Property(null)
], StockChartLegendSettings.prototype, "itemPadding", void 0);
__decorate([
    Property('Center')
], StockChartLegendSettings.prototype, "alignment", void 0);
__decorate([
    Complex({ fontFamily: null, size: null, fontStyle: null, fontWeight: null, color: null }, StockChartFont)
], StockChartLegendSettings.prototype, "textStyle", void 0);
__decorate([
    Property(10)
], StockChartLegendSettings.prototype, "shapeHeight", void 0);
__decorate([
    Property(10)
], StockChartLegendSettings.prototype, "shapeWidth", void 0);
__decorate([
    Complex({}, StockChartBorder)
], StockChartLegendSettings.prototype, "border", void 0);
__decorate([
    Complex({ left: 0, right: 0, top: 0, bottom: 0 }, StockMargin)
], StockChartLegendSettings.prototype, "margin", void 0);
__decorate([
    Complex({ left: 0, right: 0, top: 0, bottom: 0 }, ContainerPadding)
], StockChartLegendSettings.prototype, "containerPadding", void 0);
__decorate([
    Property(8)
], StockChartLegendSettings.prototype, "shapePadding", void 0);
__decorate([
    Property('transparent')
], StockChartLegendSettings.prototype, "background", void 0);
__decorate([
    Property(1)
], StockChartLegendSettings.prototype, "opacity", void 0);
__decorate([
    Property(true)
], StockChartLegendSettings.prototype, "toggleVisibility", void 0);
__decorate([
    Property(null)
], StockChartLegendSettings.prototype, "description", void 0);
__decorate([
    Property(3)
], StockChartLegendSettings.prototype, "tabIndex", void 0);
__decorate([
    Property(null)
], StockChartLegendSettings.prototype, "title", void 0);
__decorate([
    Complex({ fontFamily: null, size: null, fontStyle: null, fontWeight: null, color: null }, StockChartFont)
], StockChartLegendSettings.prototype, "titleStyle", void 0);
__decorate([
    Property('Top')
], StockChartLegendSettings.prototype, "titlePosition", void 0);
__decorate([
    Property(100)
], StockChartLegendSettings.prototype, "maximumTitleWidth", void 0);
__decorate([
    Property(true)
], StockChartLegendSettings.prototype, "enablePages", void 0);
__decorate([
    Property(false)
], StockChartLegendSettings.prototype, "isInversed", void 0);
__decorate([
    Property(null)
], StockChartLegendSettings.prototype, "template", void 0);
/**
 * `Legend` module is used to render legend for the stockchart.
 */
export class StockLegend extends BaseLegend {
    constructor(chart) {
        super(chart);
        this.library = this;
        this.addEventListener();
    }
    /**
     * Binding events for Stocklegend module.
     *
     * @returns {void}
     */
    addEventListener() {
        if (this.chart.isDestroyed) {
            return;
        }
        this.chart.on('click', this.click, this);
        this.chart.on(Browser.touchEndEvent, this.mouseEnd, this);
        this.chart.on(Browser.touchMoveEvent, this.mouseMove, this);
    }
    /**
     * UnBinding events for Stocklegend module.
     *
     * @returns {void}
     */
    removeEventListener() {
        if (this.chart.isDestroyed) {
            return;
        }
        this.chart.off('click', this.click);
        this.chart.off(Browser.touchEndEvent, this.mouseEnd);
        this.chart.off(Browser.touchMoveEvent, this.mouseMove);
    }
    /**
     * To handle mouse move for Stocklegend module.
     *
     * @param {MouseEvent} e - The mouse move event.
     * @returns {void}
     */
    mouseMove(e) {
        if (this.chart.legendSettings.visible && !this.chart.isTouch) {
            this.move(e);
        }
    }
    /**
     * To handle mouse end for Stocklegend module.
     *
     * @param {MouseEvent} e - The mouse move event.
     * @returns {void}
     */
    mouseEnd(e) {
        if (this.chart.legendSettings.visible && this.chart.isTouch) {
            this.move(e);
        }
    }
    getLegendOptions(visibleSeriesCollection) {
        this.legendCollections = [];
        let seriesType;
        let fillColor;
        if (visibleSeriesCollection.length > 1) {
            this.legend.mode = 'Series';
        }
        for (const series of visibleSeriesCollection) {
            if (this.legend.mode === 'Series') {
                if (series.category !== 'Indicator') {
                    seriesType = series.type;
                    let seriesColor;
                    if (this.hasGradient(series) === 'linear_gradient') {
                        seriesColor = `url(#${this.chart.element.id}_stockChart_chart_series_${series.index}_linear_gradient)`;
                    }
                    else if (this.hasGradient(series) === 'radial_gradient') {
                        seriesColor = `url(#${this.chart.element.id}_stockChart_chart_series_${series.index}_radial_gradient)`;
                    }
                    else {
                        seriesColor = series.interior;
                    }
                    fillColor = (series.pointColorMapping && series.points.length > 0) ?
                        (series.points[0].interior ? series.points[0].interior : seriesColor) : seriesColor;
                    this.legendCollections.push(new LegendOptions(series.name, fillColor, series.legendShape, (series.category === 'TrendLine' ?
                        this.chart.series[series.sourceIndex].trendlines[series.index].visible : series.visible), seriesType, series.legendImageUrl, series.marker.shape, series.marker.visible));
                    if (this.chart.legendSettings.template) {
                        const sz = measureLegendTemplateSize(this.legendID, this.chart, this.legendCollections.length - 1);
                        this.legendCollections[this.legendCollections.length - 1].templateSize = sz;
                        this.legendCollections[this.legendCollections.length - 1].textSize = sz;
                        this.legendCollections[this.legendCollections.length - 1].template =
                            this.chart.legendSettings.template;
                    }
                }
            }
        }
    }
    /**
     * Retrieves the bounds of the legend.
     *
     * @param {Size} availableSize - The available size for the legend.
     * @param {Rect} legendBound - The bounds of the legend element.
     * @param {StockChartLegendSettingsModel} legend - The settings for the legend.
     * @returns {void}
     * @private
     */
    getLegendBounds(availableSize, legendBound, legend) {
        this.calculateLegendTitle(legend, legendBound);
        const padding = legend.padding;
        this.isTitle = legend.title ? true : false;
        const titlePosition = legend.titlePosition;
        let extraWidth = 0;
        let extraHeight = 0;
        let legendOption;
        const arrowHeight = this.arrowHeight;
        const arrowWidth = this.arrowWidth;
        const verticalArrowSpace = this.isVertical && !legend.enablePages ? arrowHeight : 0;
        let titleSpace = this.isTitle && titlePosition === 'Top' ? this.fivePixel + this.legendTitleSize.height : 0;
        titleSpace = this.isTitle && this.isVertical && titlePosition !== 'Top' ? this.fivePixel + this.legendTitleSize.height : titleSpace;
        if (!this.isVertical) {
            extraHeight = !legend.height ? ((availableSize.height / 100) * 5) : 0;
        }
        else {
            extraWidth = !legend.width ? ((availableSize.width / 100) * 5) : 0;
        }
        legendBound.height += (extraHeight);
        legendBound.width += extraWidth;
        const shapePadding = legend.shapePadding;
        const shapeWidth = legend.shapeWidth;
        let maximumWidth = 0;
        let rowWidth = 0;
        let legendWidth = 0;
        let columnHeight = 0;
        let rowCount = 0;
        let titlePlusArrowSpace = 0;
        let legendEventArgs;
        this.maxItemHeight = Math.max(measureText('MeasureText', legend.textStyle, this.chart.themeStyle.legendLabelFont).height, legend.shapeHeight);
        let render = false;
        for (let i = 0; i < this.legendCollections.length; i++) {
            legendOption = this.legendCollections[i];
            if (regSup.test(legendOption.text)) {
                legendOption.text = getUnicodeText(legendOption.text, regSup);
            }
            if (regSub.test(legendOption.text)) {
                legendOption.text = getUnicodeText(legendOption.text, regSub);
            }
            legendEventArgs = {
                fill: legendOption.fill, text: legendOption.text, shape: legendOption.shape,
                markerShape: legendOption.markerShape, name: legendRender, cancel: false
            };
            this.chart.trigger(legendRender, legendEventArgs);
            legendOption.text = legendEventArgs.text;
            legendOption.render = !legendEventArgs.cancel;
            legendOption.shape = legendEventArgs.shape;
            legendOption.fill = legendEventArgs.fill;
            legendOption.markerShape = legendEventArgs.markerShape;
            legendOption.textSize = measureText(legendOption.text, legend.textStyle, this.chart.themeStyle.legendLabelFont);
            if (legendOption.render) {
                render = true;
                legendWidth = shapePadding + shapeWidth + legendOption.textSize.width + (!this.isVertical ? (i === 0) ? padding :
                    this.itemPadding : padding);
                rowWidth = rowWidth + legendWidth;
                if (!legend.enablePages && !this.isVertical) {
                    titlePlusArrowSpace = this.isTitle && titlePosition !== 'Top' ? this.legendTitleSize.width + this.fivePixel : 0;
                    titlePlusArrowSpace += arrowWidth;
                }
                if (legendBound.width < (padding + rowWidth + titlePlusArrowSpace) || this.isVertical) {
                    maximumWidth = Math.max(maximumWidth, (rowWidth + padding + titlePlusArrowSpace -
                        (this.isVertical ? 0 : legendWidth)));
                    if (rowCount === 0 && (legendWidth !== rowWidth)) {
                        rowCount = 1;
                    }
                    rowWidth = this.isVertical ? 0 : legendWidth;
                    rowCount++;
                    columnHeight = (rowCount * (this.maxItemHeight + (this.isVertical ? this.itemPadding : padding))) +
                        padding + titleSpace + verticalArrowSpace;
                }
            }
        }
        columnHeight = Math.max(columnHeight, (this.maxItemHeight + padding) + padding + titleSpace);
        this.isPaging = legendBound.height < columnHeight;
        if (this.isPaging && !legend.enablePages) {
            if (!this.isVertical) {
                columnHeight = (this.maxItemHeight + padding) + padding + (titlePosition === 'Top' ? titleSpace : 0);
            }
        }
        this.totalPages = rowCount;
        if (!this.isPaging && !this.isVertical) {
            rowWidth += this.isTitle && titlePosition !== 'Top' ? (this.fivePixel + this.legendTitleSize.width + this.fivePixel) : 0;
        }
        if (render) {
            this.setBounds(Math.max((rowWidth + padding), maximumWidth), columnHeight, legend, legendBound);
        }
        else {
            this.setBounds(0, 0, legend, legendBound);
        }
    }
    /**
     * Retrieves the render point for the legend.
     *
     * @param {LegendOptions} legendOptions - The options for the legend.
     * @param {ChartLocation} start - The starting point for rendering the legend.
     * @param {number} textPadding - The padding around legend text.
     * @param {LegendOptions} prevLegend - The options for the previous legend.
     * @param {Rect} rect - The bounding for the legend.
     * @param {number} count - The count of legends.
     * @param {number} firstLegend - The index of the first legend.
     * @returns {void}
     * @private
     */
    getRenderPoint(legendOptions, start, textPadding, prevLegend, rect, count, firstLegend) {
        const previousBound = (prevLegend.location.x + textPadding + prevLegend.textSize.width);
        const padding = this.legend.padding;
        if ((previousBound + (legendOptions.textSize.width + textPadding - this.itemPadding)) >
            (rect.x + rect.width + this.legend.shapeWidth / 2) ||
            this.isVertical) {
            legendOptions.location.x = start.x;
            legendOptions.location.y = (count === firstLegend) ? prevLegend.location.y :
                prevLegend.location.y + this.maxItemHeight + (this.isVertical ? this.itemPadding : padding);
        }
        else {
            legendOptions.location.x = (count === firstLegend) ? prevLegend.location.x : previousBound;
            legendOptions.location.y = prevLegend.location.y;
        }
        const availwidth = (this.legendBounds.width + this.legendBounds.x) - (legendOptions.location.x +
            textPadding - this.itemPadding - this.legend.shapeWidth / 2);
        legendOptions.text = textTrim(+availwidth.toFixed(4), legendOptions.text, this.legend.textStyle, this.chart.enableRtl, this.chart.themeStyle.legendLabelFont);
    }
    /**
     * Handles the click event on the legend.
     *
     * @param {number} index - The index of the legend item.
     * @returns {void}
     * @private
     */
    legendClick(index) {
        const chart = this.chart;
        const seriesIndex = chart.legendSettings.mode === 'Series' ? index : 0;
        const targetSeries = chart.visibleSeries[seriesIndex];
        const targetLegend = this.legendCollections[index];
        const legendClickArgs = {
            legendText: targetLegend.text, legendShape: targetLegend.shape,
            chart: chart, series: targetSeries, name: legendClick, cancel: false
        };
        this.chart.trigger(legendClick, legendClickArgs);
        targetSeries.legendShape = legendClickArgs.legendShape;
        if (targetSeries.fill !== null) {
            chart.visibleSeries[index].interior = targetSeries.fill;
        }
        if (chart.legendSettings.toggleVisibility) {
            chart.legendClicked = true;
            this.changeSeriesVisiblity(targetSeries, targetSeries.visible);
            targetLegend.visible = targetSeries.category === 'TrendLine' ? chart.series[targetSeries.sourceIndex].trendlines[targetSeries.index].visible :
                (targetSeries.visible);
            this.refreshLegendToggle(chart);
        }
    }
    hasGradient(series) {
        if (!isNullOrUndefined(series.linearGradient) && series.linearGradient.gradientColorStop.length > 0) {
            return 'linear_gradient';
        }
        else if (!isNullOrUndefined(series.radialGradient) && series.radialGradient.gradientColorStop.length > 0) {
            return 'radial_gradient';
        }
        else {
            return '';
        }
    }
    refreshLegendToggle(chart) {
        const bounds = chart.stockLegendModule.legendBounds;
        chart.stockLegendModule.renderLegend(chart, chart.legendSettings, bounds);
    }
    changeSeriesVisiblity(series, visibility) {
        series.visible = !visibility;
        if (this.SecondaryAxis(series.yAxis)) {
            series.yAxis.internalVisibility = series.yAxis.series.some((value) => (value.visible));
        }
        if (this.SecondaryAxis(series.xAxis)) {
            series.xAxis.internalVisibility = series.xAxis.series.some((value) => (value.visible));
        }
    }
    SecondaryAxis(axis) {
        return (this.chart.axes.indexOf(axis) > -1);
    }
    /**
     * To show the tooltip for the trimmed text in legend.
     *
     * @param {Event | PointerEvent} event - The click event.
     * @returns {void}
     */
    click(event) {
        if (!this.chart.legendSettings.visible) {
            return;
        }
        const pageY = this.chart.mouseY;
        const pageX = this.chart.mouseX;
        const legendItemsId = [this.legendID + '_text_', this.legendID + '_shape_marker_',
            this.legendID + '_shape_', this.legendID + '_template_'];
        let targetId = event.target.id;
        if (!targetId || targetId.indexOf(this.legendID + '_template_') === -1) {
            const tplAncestor = event.target.closest(`[id^="${this.legendID}_template_"]`);
            if (tplAncestor && tplAncestor.id) {
                targetId = tplAncestor.id;
            }
        }
        let seriesIndex;
        for (const id of legendItemsId) {
            if (targetId.indexOf(id) > -1) {
                seriesIndex = parseInt(targetId.split(id)[1], 10);
                this.legendClick(seriesIndex);
                break;
            }
        }
        if (targetId.indexOf(this.legendID + '_pagedown') > -1) {
            this.changePage(event, false);
        }
        else if (targetId.indexOf(this.legendID + '_pageup') > -1) {
            this.changePage(event, true);
        }
        this.legendRegions.filter((region) => {
            return (withInBounds(pageX, (pageY + (this.isPaging ? (this.currentPageNumber - 1) *
                this.translatePage(false, null, 1, 2) : 0)), region.rect));
        });
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        return 'StockLegend';
    }
    /**
     * To destroy the Legend.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        this.removeEventListener();
    }
}
